import { gql } from '@apollo/client';

const GET_LAST_CHANGELOG_QUERY = gql`
  query GetLastChangelogQuery {
    getLastChangelog {
      id
      title
      seen
      log
      startDate
      endDate
    }
  }
`;

const SEE_CHANGELOG = gql`
  mutation SeeChangelog($data: SeeChangelogInput!) {
    seeChangelog(data: $data)
  }
`;

export { GET_LAST_CHANGELOG_QUERY, SEE_CHANGELOG };
